import { motion } from "framer-motion";
import { FTC_LOGO_URL } from "../lib/constants";
import { useI18n } from "../context/I18nContext";

export const ConciergePartner = () => {
  const { t } = useI18n();
  return (
    <section data-testid="concierge-partner" className="bg-white py-20 md:py-28 px-6 lg:px-10 border-t border-navy/10">
      <div className="max-w-[1100px] mx-auto grid md:grid-cols-2 gap-12 md:gap-16 items-center">
        <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }} className="flex justify-center">
          <div className="bg-navy rounded-2xl p-10 w-full flex items-center justify-center">
            <img src={FTC_LOGO_URL} alt="French Touch Concierge" className="h-40 w-auto object-contain" />
          </div>
        </motion.div>
        <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}>
          <p className="font-sans text-gold text-[11px] tracking-luxury uppercase mb-5">{t("concierge.label")}</p>
          <h2 className="font-serif text-navy text-3xl md:text-5xl leading-tight mb-6">
            {t("concierge.hA")} <span className="italic text-gold">{t("concierge.hB")}</span>
          </h2>
          <p className="font-sans text-navy/60 text-sm md:text-base leading-relaxed">{t("concierge.body")}</p>
        </motion.div>
      </div>
    </section>
  );
};
